import { app as appType } from '@/types/entities';

export type appData = Record<string, unknown> & {
  scopes?: string[];
};

export type appView = Omit<appType, 'data'> & {
  data: appData;
};

export const convertAppToView = (app: appType): appView => {
  return {
    ...app,
    data: app.data ? JSON.parse(app.data) : {},
  };
};
